import {Layout, Spinner} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {px} from '../../utils';

const AppLoadingIndicator = () => {
  return (
    <Layout style={styles.loadingContainer}>
      <Spinner size="giant" />
    </Layout>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: px(175),
  },
});

export default AppLoadingIndicator;
